import React, { FC, useState } from 'react';
import { Feedback } from '../../../../config/api/models/Feedback';
import { DateColumn, FeedbackColumn, TableHeaders } from './Atoms';
import { FeedbackRow } from './FeedbackRow';
import { useTranslation } from 'react-i18next';
import { FeedbackTargetAudience } from '../FeedbackTargetAudience';
import { TargetedStudents } from '../../types';
import { useUser } from 'src/modules/shared';
import { IGroupStudent } from 'src/config/api/models/User';

type ExistingFeedbackProps = {
  data: Feedback[];
  selectedGroupData?: IGroupStudent[];
  onUpdate: () => void;
};

export const ExistingFeedback: FC<ExistingFeedbackProps> = ({
  data,
  selectedGroupData,
  onUpdate,
}) => {
  const { t } = useTranslation();
  const { isTeacher } = useUser();
  const [targetedStudents, setTargetedStudents] = useState<TargetedStudents | undefined>();

  return (
    <div>
      <TableHeaders>
        <DateColumn header>{t('feedback.date')}</DateColumn>
        <FeedbackColumn>{t('feedback.feedback')}</FeedbackColumn>
      </TableHeaders>
      {data
        .sort((a, b) => (a.createdAt < b.createdAt ? 1 : -1))
        .map(feedback => (
          <FeedbackRow
            key={feedback.id}
            selectedGroupData={selectedGroupData}
            data={feedback}
            onUpdate={onUpdate}
          />
        ))}
      {isTeacher && <FeedbackTargetAudience
        readOnly
        targetedStudents={targetedStudents}
        onUpdateTargetedStudents={setTargetedStudents}
      />}
    </div>
  );
};
